import { Component, Input, Output, EventEmitter, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApplicantInterviewFormService } from './applicant-interview-form.service';
import { FormsDataServiceInterface } from '@discoverer/dynamic-forms/dyn-forms/services';
import { UserDataService } from '@discoverer/app-core';
import { IDiscussionNoteDto } from '../../../../../models/dtos/discussion-note.dto';
import { ApplicantService } from '../../../services/apis/applicant.service';
import { IApplicantInterviewDto } from '@app/ATS/models/dtos/applicant-interview.dto';
import { OptionDataServiceInterface } from '@discoverer/dynamic-forms/option-lists/shared-services/data-service';
import { HasuraOptionService } from '@discoverer/dynamic-forms/option-lists/shared-services/hasura-option-service';
import { OptionService } from '../../../services/option.service';
import { isSelected } from '@progress/kendo-react-inputs';

@Component({
    selector: 'app-interview-form',
    templateUrl: './applicant-interview-form.component.html',
    styleUrls: ['./applicant-interview-form.component.scss'],
    providers: [
        { provide: FormsDataServiceInterface, useClass: ApplicantInterviewFormService },
        { provide: OptionDataServiceInterface, useClass: HasuraOptionService },

    ]
})
export class ApplicantInterviewFormComponent implements OnInit {
    public user: any;

    @Input()
    public model: any = {};

    @Input()
    formKey: string;

    @Input()
    appId = 'ats';

    @Input()
    tabId = 'applicants';
    public isLoading = false;

    @Output() isSubmitted = new EventEmitter();

    @ViewChild('dynForm', { static: false }) dynForm;

    public isEditMode = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private _userService: UserDataService,
        private _optionsService: OptionDataServiceInterface,
        private _applicantService: ApplicantService) {
        this._userService.loggedInUser.subscribe((userData) => this.user = userData);
    }
    async ngOnInit(): Promise<void> {



console.log(this.model);

this.cdr.detectChanges();
    }

    public save() {
        this.isLoading = true;

        if (!this.dynForm.form.valid) {
            this.isLoading = false;
        }

        this.dynForm.submit();
    }

    public async onSubmit(interview: IApplicantInterviewDto) {
        if (interview) {
            this.isLoading = true;
            this.isEditMode = true;
            let listId = this.model.logListId;



            var notes: IDiscussionNoteDto[] = [{
                body: 'Edited Interview Information',
                notesListId: listId,
                createdOn: new Date().toString(),
                createdById: +this.user.id
            }];

            this._applicantService.createApplicantNotesForLog(this.model.applicantId, listId, notes).subscribe(x => {
                this.isSubmitted.emit(true);
                this.isLoading = false;
                this.isEditMode = false;
            });
        }
        else
            this.isLoading = false;

    }
}
